import React from 'react'
import { useForm, useFormState } from 'react-final-form'
import { Form, TextArea, Icon, Popup, Button } from 'semantic-ui-react'

import { Field } from './FieldAdapter'
import { LINEAGE_OPTIONS } from '../../../consts'
import { RevertToDefaultButton } from '../RevertToDefaultButton'
import { ProductLocalizedKeys } from '../form/types'

interface Props {
  product: Partial<ProductLocalizedKeys>
}

export const Details = ({ product }: Props) => {
  const {
    mutators: { titleCase },
    change,
  } = useForm()
  // For revert to default we must compare product values to the form state
  // values because of the FieldAdapter component that changes "" -> null.
  // To decide if a value is the same as the products don't use the fields 'input'
  const { values } = useFormState()

  return (
    <>
      <Field
        name="name"
        formatOnBlur={true}
        format={(value: string | undefined) => (value ? value.trim() : '')}
      >
        {({ input, meta }) => (
          <Form.Field error={(meta.touched && meta.error) || meta.submitError}>
            <div className="field" style={{ display: 'flex', gap: '10px', marginBottom: '0' }}>
              <label>Name</label>
              <RevertToDefaultButton
                handleClick={() => change('name', product?.name)}
                isDefault={product?.name === values.name}
              />
            </div>
            <Form.Input error={meta.touched && meta.error} type="text" action {...input}>
              <input />
              <Popup
                content="Titlecase"
                position="top center"
                trigger={
                  <Button
                    type="button"
                    icon
                    tabIndex="-1"
                    onClick={() => {
                      titleCase('name')
                    }}
                  >
                    <Icon name="magic" />
                  </Button>
                }
              />
            </Form.Input>
          </Form.Field>
        )}
      </Field>

      <Field
        name="description"
        type="string"
        formatOnBlur={true}
        format={(value: string | undefined) => (value ? value.trim() : '')}
      >
        {({ input, meta }) => (
          <Form.Field error={!!((meta.touched && meta.error) || meta.submitError)}>
            <div className="field" style={{ display: 'flex', gap: '10px', marginBottom: '0' }}>
              <label>Description</label>
              <RevertToDefaultButton
                handleClick={() => change('description', product?.description)}
                isDefault={product?.description === values.description}
              />
            </div>
            <TextArea
              {...input}
              rows="12"
              placeholder="Product Description"
              style={{ width: '100%' }}
            />
            {/* TextArea doesn't support an error key, manually added it here */}
            {meta.touched && meta.error && (
              <div className="ui pointing above prompt label" role="alert" aria-atomic="true">
                {meta.error}
              </div>
            )}
          </Form.Field>
        )}
      </Field>

      <Field name="lineage">
        {({ input, meta }) => (
          <>
            <Form.Select
              label={
                <div className="field" style={{ display: 'flex', gap: '10px', marginBottom: '0' }}>
                  <label>Lineage</label>
                  <RevertToDefaultButton
                    handleClick={() => change('lineage', product?.category)}
                    isDefault={product?.category === values.lineage}
                  />
                </div>
              }
              clearable
              selectOnBlur={false}
              error={(meta.error || meta.submitError) && meta.touched}
              onChange={(_, { value }) => input.onChange(value)}
              options={[...LINEAGE_OPTIONS]}
              value={input.value}
            />
          </>
        )}
      </Field>

      <Field
        name="category_label"
        formatOnBlur={true}
        format={(value: string | undefined) => (value ? value.trim() : '')}
      >
        {({ input, meta }) => (
          <Form.Field error={meta.error || meta.submitError}>
            <div className="field" style={{ display: 'flex', gap: '10px', marginBottom: '0' }}>
              <label>Brand Subtype</label>
              <RevertToDefaultButton
                handleClick={() => change('category_label', product?.brand_subtype)}
                isDefault={
                  (product?.brand_subtype === null && values.category_label === '') ||
                  product?.brand_subtype === values.category_label
                }
              />
            </div>
            <Form.Input
              placeholder="string"
              error={meta.touched && meta.error}
              type="text"
              {...input}
            />
          </Form.Field>
        )}
      </Field>
    </>
  )
}
